import { Divider, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import CompanyDetailSubsectionRow from './components/CompanyDetailsSubsectionRow';
import CompanyDetailSubsectionItem from './components/CompanyDetailsSubsectionItem';
import CustomButton from '../../../../../../../components/button/CustomButton';
import CompanyOverview from './components/CompanyOverview/CompanyOverview';
import CompanyAbout from './components/CompanyAbout/CompanyAbout';
import CompanyTeam from './components/CompanyTeam/CompanyTeam';
import CompanyClients from './components/CompanyClients/CompanyClients';
import CompanyOfficeLocations from './components/CompanyOfficeLocations/CompanyOfficeLocations';
import CompanyWorkingLanguages from './components/CompanyWorkingLanguages/CompanyWorkingLanguages';
import CompanyCertifications from './components/CompanyCertifications/CompanyCertifications';
import CompanyAwards from './components/CompanyAwards/CompanyAwards';
import CompanyTargetIndustries from './components/CompanyTargetIndustries/CompanyTargetIndustries';
import CompanyTargetMarkets from './components/CompanyTargetMarkets/CompanyTargetMarkets';
import CompanySocialMedia from './components/CompanySocialMedia/CompanySocialMedia';
import CompanyServices from './components/CompanyServices/CompanyServices';
import CompanyTechTools from './components/CompanyTechTools/CompanyTechTools';
import CompanyTechPlatforms from './components/CompanyTechPlatforms/CompanyTechPlatforms';
import CompanyTechLanguages from './components/CompanyTechLanguages/CompanyTechLanguages';

const CompanyDetailSubsection = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Stack spacing={4}>
      {/* row first */}
      <CompanyDetailSubsectionRow
        sx={{
          justifyContent: 'space-between',
        }}
        row={[
          // element first
          <CompanyDetailSubsectionItem
            title={t('settings.companyProfile.overview')}
            content={(isOverviewModalOpen, setIsOverviewModalOpen) => (
              <CompanyOverview
                isOverviewModalOpen={isOverviewModalOpen}
                setIsOverviewModalOpen={setIsOverviewModalOpen}
              />
            )}
          />,

          // element second
          <CompanyDetailSubsectionItem
            title={t('settings.companyProfile.about')}
            content={(isEditModalOpen, setIsEditModalOpen) => (
              <CompanyAbout
                isEditModalOpen={isEditModalOpen}
                setIsEditModalOpen={setIsEditModalOpen}
              />
            )}
          />,

          // element third
          // team & clients columnn
          <Stack spacing={2} sx={{ width: '100%' }}>
            <CompanyDetailSubsectionItem
              title={t('settings.companyProfile.team')}
              actionButton={
                <CustomButton
                  variant="primaryText"
                  onClick={() => navigate('./team')}
                  sx={{ fontSize: '14px' }}
                >
                  {t('common.viewAll')}
                </CustomButton>
              }
              content={<CompanyTeam />}
            />

            <CompanyDetailSubsectionItem
              title={t('settings.companyProfile.clients')}
              content={(isEditModalOpen, setIsEditModalOpen) => (
                <CompanyClients
                  isEditModalOpen={isEditModalOpen}
                  setIsEditModalOpen={setIsEditModalOpen}
                />
              )}
            />
          </Stack>,
        ]}
      />

      <Divider />

      {/* row second */}
      <CompanyDetailSubsectionRow
        sx={{ justifyContent: 'space-between' }}
        row={[
          // element first
          // office locations & working languages
          <Stack spacing={2} sx={{ width: '100%' }}>
            <CompanyDetailSubsectionItem
              title={t('settings.companyProfile.officeLocations')}
              content={(isEditModalOpen, setIsEditModalOpen) => (
                <CompanyOfficeLocations
                  isEditModalOpen={isEditModalOpen}
                  setIsEditModalOpen={setIsEditModalOpen}
                />
              )}
            />

            <CompanyDetailSubsectionItem
              title={t('settings.companyProfile.workingLanguages')}
              content={(isEditModalOpen, setIsEditModalOpen) => (
                <CompanyWorkingLanguages
                  isEditModalOpen={isEditModalOpen}
                  setIsEditModalOpen={setIsEditModalOpen}
                />
              )}
            />
          </Stack>,

          // element second
          // certifications & awards
          <Stack spacing={2} sx={{ width: '100%' }}>
            <CompanyDetailSubsectionItem
              title={t('settings.companyProfile.certifications')}
              content={(isEditModalOpen, setIsEditModalOpen) => (
                <CompanyCertifications
                  isEditModalOpen={isEditModalOpen}
                  setIsEditModalOpen={setIsEditModalOpen}
                />
              )}
            />

            <CompanyDetailSubsectionItem
              title={t('settings.companyProfile.awards')}
              content={(isEditModalOpen, setIsEditModalOpen) => (
                <CompanyAwards
                  isEditModalOpen={isEditModalOpen}
                  setIsEditModalOpen={setIsEditModalOpen}
                />
              )}
            />
          </Stack>,

          // element third
          // team & clients columnn
          <Stack spacing={2} sx={{ width: '100%' }}>
            <CompanyDetailSubsectionItem
              title={t('settings.companyProfile.targetIndustries')}
              content={(isEditModalOpen, setIsEditModalOpen) => (
                <CompanyTargetIndustries
                  isEditModalOpen={isEditModalOpen}
                  setIsEditModalOpen={setIsEditModalOpen}
                />
              )}
            />

            <CompanyDetailSubsectionItem
              title={t('settings.companyProfile.targetMarkets')}
              content={(isEditModalOpen, setIsEditModalOpen) => (
                <CompanyTargetMarkets
                  isEditModalOpen={isEditModalOpen}
                  setIsEditModalOpen={setIsEditModalOpen}
                />
              )}
            />
          </Stack>,
        ]}
      />

      <Divider />

      {/* row third */}
      <CompanyDetailSubsectionRow
        sx={{ justifyContent: 'space-between' }}
        row={[
          // element first
          // social media
          <CompanyDetailSubsectionItem
            title={t('settings.companyProfile.socialMedia')}
            content={(isEditModalOpen, setIsEditModalOpen) => (
              <CompanySocialMedia
                isEditModalOpen={isEditModalOpen}
                setIsEditModalOpen={setIsEditModalOpen}
              />
            )}
          />,

          // element second
          // services & tech tools
          <Stack spacing={2} sx={{ width: '100%' }}>
            {/* <CompanyDetailSubsectionItem title="Services" content={<CompanyServices />} /> */}
            <CompanyDetailSubsectionItem
              title={t('settings.companyProfile.services')}
              content={(isEditModalOpen, setIsEditModalOpen) => (
                <CompanyServices
                  isEditModalOpen={isEditModalOpen}
                  setIsEditModalOpen={setIsEditModalOpen}
                />
              )}
            />

            <CompanyDetailSubsectionItem
              title={t('settings.companyProfile.techTools')}
              content={(isEditModalOpen, setIsEditModalOpen) => (
                <CompanyTechTools
                  isEditModalOpen={isEditModalOpen}
                  setIsEditModalOpen={setIsEditModalOpen}
                />
              )}
            />
          </Stack>,

          // element third
          // tech platforms & programming languages
          <Stack spacing={2} sx={{ width: '100%' }}>
            <CompanyDetailSubsectionItem
              title={t('settings.companyProfile.techPlatforms')}
              content={(isEditModalOpen, setIsEditModalOpen) => (
                <CompanyTechPlatforms
                  isEditModalOpen={isEditModalOpen}
                  setIsEditModalOpen={setIsEditModalOpen}
                />
              )}
            />

            <CompanyDetailSubsectionItem
              title={t('settings.companyProfile.programmingLanguages')}
              // FIXME: this is put here as an example;
              // continue to implement fully
              content={(isEditModalOpen, setIsEditModalOpen) => (
                <CompanyTechLanguages
                  isEditModalOpen={isEditModalOpen}
                  setIsEditModalOpen={setIsEditModalOpen}
                />
              )}
            />
          </Stack>,
        ]}
      />
    </Stack>
  );
};

export default CompanyDetailSubsection;
